<template>
  <div v-if="!product.title.includes('E-Gift Card')" class="pm__stock-info">
    <div v-if="product.final_sale_msg" class="pm__finalSale">{{product.final_sale_msg}}</div>
    <div class="pm__stock-info-seperator" v-if="
      product.final_sale_msg && selectedVariant && 
      product.units_left_threshold > selectedVariant.inventory_quantity"
    >|</div>
    <div class="pm__inventory-msg" v-if="
      !selectedFirstOption.bis && selectedVariant && 
      product.units_left_threshold > selectedVariant.inventory_quantity"
    >
      {{selectedVariant.inventory_quantity}} Left in Stock
    </div>
    <div class="pm__inventory-msg" v-else-if="
      selectedFirstOption.bis && 
      selectedFirstOption.bisDate!='N/A' &&
      selectedVariant && !selectedVariant.available
      "   
    >
      Estimated in stock date: {{selectedFirstOption.bisDate}}
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    },

    selectedVariant:{
      type: Object,
      default: () => ({})
    },

    selectedFirstOption:{
      type: Object,
      default: () => ({})
    }
  })
</script>